'use strict';

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};



//////////////////
// WEBPACK FOOTER
// ./~/_es-abstract@1.16.0@es-abstract/helpers/sign.js
// module id = 517
// module chunks = 128